// extracted by mini-css-extract-plugin
export default {"card":"ContainerCard_card__YjzL2"};